// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Kkm from "../../../../models/Kkm.js";
import * as Buhta_cabinet__Timestamp from "../../../../util/Timestamp.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as MelNumeral from "../../../../../../../packages/util/lib/MelNumeral.js";
import * as QrcodeReact from "qrcode.react";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ReceiptBody(Props) {
  let receipt = Props.receipt;
  const org = Belt__Belt_Option.getWithDefault(receipt.org, {
    id: 0,
    name: "",
    "type'": /* ORG_TYPE_UNSPECIFIED */ 0,
    tin: "",
    address: "",
    vat_cert_series: "",
    vat_cert_number: ""
  });
  const kkmObj = Belt__Belt_Option.getWithDefault(receipt.kkm, {
    serial_num: "",
    ofd_provider_id: 0,
    ofd_register_num: "",
    address_street: "",
    address_street1: "",
    address_street2: ""
  });
  const issue_time = DateTime.toLocalFormat(DateTime.setZone("Asia/Almaty", Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(receipt.issue_time, Buhta_cabinet__Timestamp.fromString("01.01.2000")))));
  const ofd_name = Buhta_cabinet__Kkm.Provider.toString(kkmObj.ofd_provider_id);
  const __x = receipt.items;
  const __x$1 = receipt.taxes;
  const __x$2 = receipt.payments;
  const t = receipt.taken_amount;
  const c = receipt.change_amount;
  const __x$3 = receipt.notes;
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        children: org.name
      }),
      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        className: "text-gray-medium",
        children: "БСН/БИН: " + org.tin
      }),
      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        className: "text-gray-medium",
        children: org.address
      }),
      org.vat_cert_number.length !== 0 ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          className: "text-gray-medium",
          children: "ҚҚС куәлігі/Свид-во НДС серия: " + (org.vat_cert_series + (" №" + org.vat_cert_number))
        }) : null,
      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        className: "mt-3 text-gray-medium",
        children: Buhta_cabinet__Kkm.OperationType.toString(receipt.operation_type) + (", " + Buhta_cabinet__Kkm.PaymentType.toString(receipt.payment_type))
      }),
      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        className: "text-gray-medium",
        children: "ФБ/ФП: " + receipt.ofd_receipt_id
      }),
      JsxRuntime.jsx("hr", {
        className: "mt-4"
      }),
      Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (i, item) {
        const Key = String(i);
        const match = item.item_type;
        let tmp;
        tmp = match === /* ITEM_TYPE_DISCOUNT */ 3 ? "text-gray-medium" : "text-black";
        const match$1 = item.item_type;
        let tmp$1;
        tmp$1 = match$1 === /* ITEM_TYPE_COMMODITY */ 1 ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "mt-1 text-gray-medium",
            children: MelNumeral.format({
              NAME: "Str",
              VAL: item.item_price
            }) + (" тг x " + (item.qty + (" " + item.measure_unit_short)))
          }) : null;
        const match$2 = item.item_type;
        let tmp$2;
        tmp$2 = match$2 === /* ITEM_TYPE_DISCOUNT */ 3 ? "text-gray-medium" : "text-black";
        const match$3 = item.item_type;
        let tmp$3;
        tmp$3 = match$3 === /* ITEM_TYPE_DISCOUNT */ 3 ? "-" : null;
        return JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: tmp,
                  children: item.name
                }),
                tmp$1,
                item.section_name !== "" ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                    className: "text-gray-medium",
                    children: "Бөлім/Отдел: " + item.section_name
                  }) : null
              ]
            }),
            JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
              className: Cn.fromList({
                hd: "shrink-0 ml-3",
                tl: {
                  hd: tmp$2,
                  tl: /* [] */ 0
                }
              }),
              children: [
                tmp$3,
                MelNumeral.format({
                  NAME: "Str",
                  VAL: item.total_amount
                }) + " ₸"
              ]
            })
          ],
          className: "flex justify-between mt-4"
        }, Key);
      }))),
      JsxRuntime.jsx("hr", {
        className: "mt-4"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.H5.make, {
            children: "Жиыны/Итого"
          }),
          JsxRuntime.jsx(Buhta_components__Text.H5.make, {
            children: MelNumeral.format({
              NAME: "Str",
              VAL: receipt.total_amount
            }) + " ₸"
          })
        ],
        className: "flex justify-between mt-4"
      }),
      Belt__Belt_List.length(receipt.taxes) > 0 ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "text-gray-medium",
              children: "Аралық жиын/Подытог"
            }),
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "text-gray-medium",
              children: MelNumeral.format({
                NAME: "Str",
                VAL: receipt.subtotal_amount
              }) + " ₸"
            })
          ],
          className: "flex justify-between mt-1"
        }) : null,
      Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x$1, (function (i, tax) {
        const Key = String(i);
        return JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "text-gray-medium",
              children: (
                tax.inclusive ? "Оның ішінде/В том числе " : ""
              ) + (Buhta_cabinet__Kkm.TaxType.toString(tax.tax_type) + (" " + (MelNumeral.formatInt({
                NAME: "Str",
                VAL: tax.percent
              }) + "%")))
            }),
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "text-gray-medium",
              children: MelNumeral.format({
                NAME: "Str",
                VAL: tax.tax_amount
              }) + " ₸"
            })
          ],
          className: "flex justify-between mt-1"
        }, Key);
      }))),
      Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x$2, (function (i, payment) {
        const Key = String(i);
        return JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "text-gray-medium",
              children: Buhta_cabinet__Kkm.PaymentType.toString(payment.payment_type)
            }),
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "text-gray-medium",
              children: MelNumeral.format({
                NAME: "Str",
                VAL: payment.amount
              }) + " ₸"
            })
          ],
          className: "flex justify-between mt-1"
        }, Key);
      }))),
      t !== undefined ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "text-gray-medium",
              children: "Қабылданды/Принято"
            }),
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "text-gray-medium",
              children: MelNumeral.format({
                NAME: "Str",
                VAL: t
              }) + " ₸"
            })
          ],
          className: "flex justify-between mt-1"
        }) : null,
      c !== undefined ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "text-gray-medium",
              children: "Қайыру/Сдача"
            }),
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "text-gray-medium",
              children: MelNumeral.format({
                NAME: "Str",
                VAL: c
              }) + " ₸"
            })
          ],
          className: "flex justify-between mt-1"
        }) : null,
      JsxRuntime.jsx("hr", {
        className: "mt-4"
      }),
      receipt.cashier_name !== "" ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          className: "mt-4 text-gray-medium",
          children: "Кассир: " + receipt.cashier_name
        }) : null,
      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        className: "text-gray-medium",
        children: "Күні және уақыты/Дата и время: " + issue_time
      }),
      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        className: "text-gray-medium",
        children: "МЗН/ЗНК: " + kkmObj.serial_num
      }),
      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        className: "text-gray-medium",
        children: "МТН/РНК: " + kkmObj.ofd_register_num
      }),
      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        className: "text-gray-medium",
        children: "ФДО/ОФД: " + ofd_name
      }),
      JsxRuntime.jsx("hr", {
        className: "mt-4 mb-4"
      }),
      Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x$3, (function (i, note) {
        const __x = note.lines;
        return Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (i, line) {
          const Key = String(i);
          return JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "text-gray-medium",
            children: line
          }, Key);
        })));
      }))),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(QrcodeReact.QRCodeSVG, {
          value: receipt.ofd_qr_code,
          className: "w-40"
        }),
        className: "mt-4 mb-6 flex flex-col items-center"
      })
    ]
  });
}

const make = ReceiptBody;

export {
  make,
}
/* Buhta_cabinet__Kkm Not a pure module */
